import { CLEAR_FLASH_MESSAGES } from './consts'

export default function clearFlashMessages(ids) {
  return { type: CLEAR_FLASH_MESSAGES, ids }
}
